<div class="h-100 bg-main-container font-white page-wrapper">
  <div class="order-container container mb-5">
    <div class="mb-4">
      <h1 class="fs-2 font-white fw-semibold">Order Your Kudo Kit</h1>
      <p class="fs-14 font-gray-opacity fw-semibold">Select your gear and assign to a student.</p>
    </div>

    <hr class="font-white mb-4 opacity-25" />

    <div class="content-grid">
      <div class="main-column">
        <div *ngIf="currentStep === 1" class="product-grid">
          <div class="product-card" *ngFor="let item of kitItems">
            <div class="product-image-placeholder border-radius-10 d-flex align-items-center justify-content-center mb-3">
              <img *ngIf="item.image && item.image !== 'assets/images/placeholder.png'" [src]="item.image" alt="{{ item.name }}" class="product-img w-100 h-100" />
              <div *ngIf="!item.image || item.image === 'assets/images/placeholder.png'" class="icon-box">🥋</div>
            </div>
            <div class="">
              <h1 class="fs-18 fw-semibold mb-2 font-white">{{ item.name }}</h1>
              <p class="fs-16 fw-semibold mb-2 font-blue">₹ {{ item.price }}</p>

              <div class="selection-area">
                <div class="size-selector mb-3 d-block font-gray-opacity fs-12">
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <label>Select Size:</label>
                    <span *ngIf="item.selectedSize" class="font-blue fw-semibold">Stock: {{ item.selectedSizeStock }}</span>
                  </div>
                  <div class="size-options d-flex gap-2">
                    <button
                      *ngFor="let size of item.sizes"
                      class="size-btn font-white border-radius-5 cursor-pointer flex-column d-flex align-items-center justify-content-center"
                      [class.active]="item.selectedSize === size"
                      [disabled]="item.sizeMapping && item.sizeMapping[size]?.stock <= 0"
                      (click)="selectSize(item, size)">
                      <span class="fw-semibold">{{ size }}</span>
                      <span class="fs-10 opacity-75 mt-1" *ngIf="item.sizeMapping && item.sizeMapping[size]">Qty: {{ item.sizeMapping[size].stock }}</span>
                    </button>
                  </div>
                </div>

                <div class="action-row d-flex gap-2 align-items-center" *ngIf="item.selectedSize">
                  <div class="quantity-control d-flex align-items-center border-radius-5 p-1 bg-black">
                    <button class="qty-btn border-0 font-white cursor-pointer d-flex justify-content-center align-items-center fs-20" (click)="decrementQuantity(item)">-</button>
                    <span class="qty-value text-center fw-semibold">{{ item.quantity }}</span>
                    <button
                      class="qty-btn border-0 font-white cursor-pointer d-flex justify-content-center align-items-center fs-20"
                      [disabled]="item.quantity >= item.selectedSizeStock"
                      (click)="incrementQuantity(item)">
                      +
                    </button>
                  </div>
                  <button class="add-btn px-2 py-2 w-100" [disabled]="item.selectedSizeStock <= 0" (click)="addToCart(item)">Add</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="currentStep === 2" class="student-assignment-section">
          <div class="card-section">
            <div class="d-flex mb-3">
              <div
                [innerHtml]="SVG_ICONS.BACK_BUTTON() | sanitizer : 'html'"
                routerLink="/orders"
                class="cursor-pointer"
                (click)="prevStep()"
                (keydown.enter)="prevStep()"
                (keydown.space)="prevStep()"
                tabindex="0"></div>
              <div class="font-white fs-14 fw-bold mt-1 ms-2">Back to Products</div>
            </div>

            <div class="d-flex flex-column gap-2">
              <div class="assignment-item bg-card-secondary border-gray border-radius-10 p-3 d-flex justify-content-between align-items-center gap-3" *ngFor="let item of cart; let i = index">
                <div class="item-info d-flex align-items-center gap-3">
                  <span class="fw-semibold fs-16 font-white">{{ item.name }}</span>
                  <span class="font-blue border-radius-5 p-2 fw-semibold" style="background: rgba(74, 144, 226, 0.1)">{{ item.size }}</span>
                  <span class="fs-14 font-white">₹ {{ item.price }}</span>
                </div>

                <div class="student-select-group d-flex align-items-center gap-2">
                  <mat-form-field appearance="outline" class="student-search-field">
                    <mat-label>Assign to Student</mat-label>
                    <input type="text" matInput [matAutocomplete]="auto" [(ngModel)]="item.searchText" (ngModelChange)="filterStudents(item)" placeholder="Search student..." />
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onStudentSelected(item, $event)" [displayWith]="displayStudent">
                      <mat-option *ngFor="let student of item.filteredStudents" [value]="student"> {{ student.FirstName }} {{ student.MiddleName }} {{ student.LastName }} </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>

          <div class="card-section mt-4">
            <h3 class="section-title">Additional Notes</h3>
            <div class="form-group mb-0">
              <textarea [(ngModel)]="notes" placeholder="Any special requirements or notes..." rows="3"></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="sidebar-column">
        <div class="cart-sidebar">
          <h3 class="fs-25 fw-semibold mb-3">Your Order</h3>
          <div class="cart-items d-flex flex-column gap-4 mb-3" *ngIf="cart.length > 0; else emptyCart">
            <div class="cart-item" *ngFor="let group of cartSummary">
              <div class="cart-item-header d-flex justify-content-between align-items-start mb-1">
                <span class="cart-item-name">{{ group.name }}</span>
                <button class="btn-remove border-0 font-gray-opacity bg-gray-opacity fs-20" (click)="removeGroup(group.name, group.size)">×</button>
              </div>
              <div class="cart-item-details d-flex justify-content-between align-items-center fs-14">
                <span class="font-gray-opacity fs-14">Size: {{ group.size }}</span>
                <span class="font-hwite fs-14 fw-semibold">Qty: {{ group.quantity }}</span>
                <span class="fs-14 font-blue fw-semibold">₹ {{ group.totalPrice }}</span>
              </div>
            </div>
          </div>

          <ng-template #emptyCart>
            <div class="text-center font-gray-opacity">
              <p>Your cart is empty.</p>
              <p class="fs-14">Select items from the list to get started.</p>
            </div>
          </ng-template>

          <div class="cart-footer" *ngIf="cart.length > 0">
            <div class="mb-4 d-flex justify-content-between align-items-center fs-16 fw-semibold border-bottom">
              <span>Total:</span>
              <span class="font-blue fs-25">₹ {{ totalAmount }}</span>
            </div>

            <button *ngIf="currentStep === 1" class="add-btn w-100 p-2 border-radius-10 border-0 fw-semibold cursor-pointer" (click)="nextStep()">Proceed to Assignment</button>
            <button *ngIf="currentStep === 2" class="btn btn-success w-100 p-2 border-radius-10 border-0 fw-semibold cursor-pointer" (click)="submitOrder()">Confirm Order</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-overlay d-flex align-items-center justify-content-center" *ngIf="showConfirmation">
    <div class="modal-content d-flex flex-column border-gray">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h2 class="fs-4 fw-bold font-white m-0">Confirm Order Details</h2>
        <button class="font-gray-opacity bg-none border-0 fs-25" (click)="cancelSubmit()">×</button>
      </div>

      <p class="font-gray-opacity">Please review the order details below before confirming.</p>

      <div class="order-summary-container border-gray border-radius-10 overflow-hidden d-flex flex-column">
        <div class="summary-header d-flex fw-semibold font-gray-opacity fs-14">
          <div class="col-product">Product</div>
          <div class="col-size text-center">Size</div>
          <div class="col-student">Student</div>
          <div class="col-price text-right fw-semibold font-blue">Price</div>
        </div>
        <div class="summary-body">
          <div class="summary-row" *ngFor="let item of cart">
            <div class="col-product">
              <span class="fs-18 fw-semibold mb-2 font-white">{{ item.name }}</span>
            </div>
            <div class="col-size">
              <span class="badge-size">{{ item.size }}</span>
            </div>
            <div class="col-student">
              <span class="student-name">{{ getStudentName(item.studentId) }}</span>
            </div>
            <div class="col-price text-right fw-semibold font-blue">₹ {{ item.price }}</div>
          </div>
        </div>
      </div>

      <div class="modal-footer d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center gap-4">
          <span class="font-gray-opacity fs-18">Total Amount:</span>
          <span class="font-blue fw-bold fs-20">₹ {{ totalAmount }}</span>
        </div>
        <div class="d-flex gap-2">
          <button class="close-btn px-3 py-2" (click)="cancelSubmit()" style="background-color: rgb(100, 100, 100)">Cancel</button>
          <button class="add-btn px-3 py-2" (click)="confirmSubmit()">Confirm Order</button>
        </div>
      </div>
    </div>
  </div>
</div>
